import { getCookie } from 'h3';
export default defineNuxtRouteMiddleware(() => {
  let debugPanel: string | undefined = 'false';
  let debugPanelOpen: string | undefined = 'false';
  const rootStore = useRootStore();
  if (import.meta.server) {
    const event = useRequestEvent();
    if (event) {
      debugPanel = getCookie(event, 'debugPanel');
      debugPanelOpen = getCookie(event, 'debugPanelOpen');
    }
  } else if (import.meta.client) {
    debugPanel = document.cookie
      .split('; ')
      .find((row) => row.startsWith('debugPanel='))
      ?.split('=')[1];
    debugPanelOpen = document.cookie
      .split('; ')
      .find((row) => row.startsWith('debugPanelOpen='))
      ?.split('=')[1];
  }
  if (debugPanel === undefined) debugPanel = 'false';
  if (debugPanelOpen === undefined) debugPanelOpen = 'false';
  rootStore.debugPanel = JSON.parse(debugPanel);
  rootStore.debugPanelOpen = JSON.parse(debugPanelOpen);
  const runtimeConfig = useRuntimeConfig();
  runtimeConfig.public.appDebug = rootStore.debugPanel;
});
